module.exports = __webpack_public_path__ + "static/media/poland.43330bee.svg";